import React, { useContext, useEffect, useRef, useState } from 'react'
import { useHistory, useLocation, useParams } from 'react-router-dom'
import { CButton, CFormText, CImage } from '@coreui/react'
import CloseIcon from '../../../assets/editor-close-icon.svg'
import { GlobalContext } from 'src/views/context/GlobalState'
import RosemaryToptrendingModal from 'src/components/template/rosemary/rosemaryToptrendingModal'
import { isEmpty } from 'lodash'
import RosemaryMomentModal from 'src/components/template/rosemary/rosemaryMomentModal'
import DeleteModal from 'src/components/DeleteModal/DeleteModal'
import RosemaryCarouselModal from 'src/components/template/rosemary/rosemaryCarouselModal'
import RosemaryRecentStoriesModal from 'src/components/template/rosemary/rosemaryRecentStoriesModal'
import uuid from 'react-uuid'
import { ThemeProvider } from 'theming'
import magentaHighlight from '../themes/magentaHighlight'
import neonDark from '../themes/neonDark'
import pantoneRed from '../themes/pantoneRed'
import darkInfraRed from '../themes/darkInfraRed'
import greenEnergy from '../themes/greenEnergy'
import defaultTheme from '../themes/defaultTheme'
import useAxios from 'axios-hooks'
import { BASE_COMPONENTS, TEMPLATE_V2_URL, CUSTOM_PAGES_API } from '../../utils/urls'
import { AppContext } from '../../context/app'
import RosemaryCategoriesModal from 'src/components/template/rosemary/rosemaryCategoriesModal'
import FitnessYogaAdModal from 'src/components/template/fitness/fitnessYogaAdModal'
import FitnessClassesModal from 'src/components/template/fitness/fitnessClassesModal'
import FitnessPlansModal from 'src/components/template/fitness/fitnessPlansModal'
import FitnessHeroModal from 'src/components/template/fitness/fitnessHeroModal'
import FitnessGalleriesModal from 'src/components/template/fitness/fitnessGalleriesModal'
import FitnessPackagesModal from 'src/components/template/fitness/fitnessPackagesModal'
import FitnessTrainerModal from 'src/components/template/fitness/fitnessTrainerModal'
// import * as htmlToImage from 'html-to-image'
import AddSectionModal from 'src/components/template/addSectionModal'
import RowingHeroSection from 'src/components/template/rosemary/rowingHeroSection'
import AsymmetricFlow from 'src/components/template/rosemary/asymmetricFlow'
import PromotionalLead from 'src/components/template/rosemary/promotionalLead'
import PassimCarve from 'src/components/template/rosemary/passimCarve'
import InventorySlide from 'src/components/template/rosemary/inventorySlide'
import ClassyBanners from 'src/components/template/fitness/classyBanners'
import NarrowAdmonition from 'src/components/template/fitness/narrowAdmonition'
import DefinityCards from 'src/components/template/fitness/definityCards'
import FineTunedGallery from 'src/components/template/fitness/fineTunedGallery'
import FlyerIntro from 'src/components/template/fitness/flyerIntro'
import MementoSlides from 'src/components/template/fitness/mementoSlides'
import WedgedInfo from 'src/components/template/fitness/wedgedInfo'
import DecomposedBanners from 'src/components/template/gaming/decomposedBanners'
import AdNCarousel from 'src/components/template/gaming/adNCarousel'
import ExtensiveCarouselRendition from 'src/components/template/gaming/extensiveCarouselRendition'
import ExtensiveCarouselSimple from 'src/components/template/gaming/extensiveCarouselSimple'
import BobbingCards from 'src/components/template/gaming/bobbingCards'
import DecomposedBannersModal from 'src/components/template/gaming/decomposedBannersModal'
import ExtensiveCarouselRenditionModal from 'src/components/template/gaming/extensiveCarouselRenditionModal'
import AdNCarouselModal from 'src/components/template/gaming/adNCarouselModal'
import ExtensiveCarouselSimpleModal from 'src/components/template/gaming/extensiveCarouselSimpleModal'
import BobbingCardsModal from 'src/components/template/gaming/bobbingCardsModal'
import TripleCardCarousel from 'src/components/template/gaming/tripleCardCarousel'
import TripleCardCarouselModal from 'src/components/template/gaming/tripleCardCarouselModal'
import DefaultBanner from 'src/components/template/default/defaultBanner'
import DefaultBannerModal from 'src/components/template/default/defaultBannerModal'
import DefaultSwimlane from 'src/components/template/default/defaultSwimlane'
import DefaultSwimlaneModal from 'src/components/template/default/defaultSwimlaneModal'
import DefaultArtistSwimlane from 'src/components/template/default/defaultArtistSwimlane'
import DefaultVenueSwimlane from 'src/components/template/default/defaultVenueSwimlane'
import DefaultArtistSwimlaneModal from 'src/components/template/default/defaultArtistSwimlaneModal'
import DefaultVenueSwimlaneModal from 'src/components/template/default/defaultVenueSwimlaneModal'
import AddIcon from '../../../assets/add-icon.svg'
import Editor from 'src/components/Editor/Editor'
import { createPageUrl } from 'src/views/utils/helper'
import PassimCarvePlayer from 'src/components/template/rosemary/passimCarvePlayer'
import PassimCarvePlayerModal from 'src/components/template/rosemary/passimCarvePlayerModal'
import ClassBannerPlayer from 'src/components/template/fitness/classBannerPlayer'
import ClassyBannerPlayerModal from 'src/components/template/fitness/classyBannerPlayerModal'
import DefaultBannerPlayer from 'src/components/template/default/defaultBannerPlayer'
import DefaultBannerPlayerModal from 'src/components/template/default/defaultBannerPlayerModal'

const themes = [defaultTheme, magentaHighlight, neonDark, pantoneRed, darkInfraRed, greenEnergy]

const StaticPageEditor = () => {
  const templateRef = useRef(null)
  const location = useLocation()
  const history = useHistory()
  let { pageId } = useParams()
  const { setLoader, accountObj } = useContext(AppContext)
  const { signedIn } = useContext(GlobalContext)
  let customerId = localStorage.getItem('customer_id')
  let sessionId = localStorage.getItem('sessionId')
  const [modalState, setModalState] = useState({})
  const [isEdit, setIsEdit] = useState(true)
  const [deleteModal, setDeleteModal] = useState(false)
  const [editorCloseModal, setEditorCloseModal] = useState(false)
  const [addModalState, setAddModalState] = useState({})
  const [selectedComponentId, setSelectedComponentId] = useState('')
  const [themeIndex, setThemeIndex] = useState(0)
  // const [templateData, setTemplateData] = useState({})
  const [pageData, setPageData] = useState({})
  const [htmlData, setHtmlData] = useState('')
  const [totalWordCount, setTotalWordCount] = useState(0)
  const [premiumComponentExist, setPremiumComponentExist] = useState(false)

  const isCustomPageEditor =
    location.pathname === `/custom-editor/${pageId}` && pageData?.type === 'CUSTOM'

  const [componentData, setComponentData] = useState([])

  const [{ data: templateList, loading: templateListLoading }, templateListCall] = useAxios(
    {
      url: TEMPLATE_V2_URL,
      method: 'get',
    },
    { manual: true },
  )

  const [{ data: baseComponentList, loading: baseComponentLoading }, baseComponentCall] = useAxios(
    {
      url: BASE_COMPONENTS,
      method: 'get',
    },
    { manual: true },
  )

  const [{ data: pagesList, loading: pagesListLoading }, pagesListCall] = useAxios(
    {
      url: CUSTOM_PAGES_API,
      method: 'get',
    },
    { manual: true },
  )

  const [{ data: pagesUpdate, loading: pagesUpdateLoading }, pagesUpdateCall] = useAxios(
    {
      url: CUSTOM_PAGES_API,
      method: 'put',
    },
    { manual: true },
  )

  useEffect(() => {
    setLoader(templateListLoading || baseComponentLoading || pagesListLoading || pagesUpdateLoading)
  }, [templateListLoading, baseComponentLoading, pagesListLoading, pagesUpdateLoading])

  useEffect(() => {
    if (templateList && templateList.success) {
      let tempData = templateList?.data.filter((info) => info?.is_published)

      if (!isEmpty(tempData)) {
        let particularTemplateData = tempData[0]
        // setTemplateData(particularTemplateData)
        if (!isEmpty(particularTemplateData)) {
          let tempThemeIndex = themes.findIndex(
            (info) => info.name === particularTemplateData?.selected_theme?.name,
          )
          if (tempThemeIndex > -1) {
            setThemeIndex(tempThemeIndex)
          }
        }
      }
    }
  }, [templateList])

  useEffect(() => {
    if (pagesList && pagesList.success) {
      console.log(pagesList.data)
      let pageData = pagesList.data[0]
      setPageData(pageData)
      if (pageData.type === 'STATIC' && pageData?.content) {
        setHtmlData(pageData?.content)
      } else if (pageData.type === 'CUSTOM') {
        setComponentData(pageData?.components)
      }
    }
  }, [pagesList])

  useEffect(() => {
    if (!customerId || !sessionId || !signedIn) {
      history.push({ pathname: '/login', state: location.pathname })
    } else {
      getTemplateData()
    }
    if (!pageId) {
      history.push('/')
    }
  }, [])

  useEffect(() => {
    if (location.pathname === '/template-preview') {
      setIsEdit(false)
    }
  }, [])

  useEffect(() => {
    checkPremiumComponent()
  }, [componentData])

  const checkPremiumComponent = () => {
    const componentIdArr = componentData.map((info) => info._id)

    let uniqueArr = componentIdArr.filter(function (obj) {
      return accountObj?.allowed_components.indexOf(obj) == -1
    })

    if (uniqueArr.length > 0) {
      setPremiumComponentExist(true)
      return
    }
    setPremiumComponentExist(false)
  }

  const checkPremiumComponentId = (componentId) => {
    return !isEmpty(accountObj?.allowed_components)
      ? !accountObj?.allowed_components.includes(componentId)
      : true
  }

  const getTemplateData = async () => {
    if (pageId) {
      pagesListCall({
        params: {
          custom_page_id: pageId,
        },
      })
      templateListCall()
      baseComponentCall()
    } else {
      isCustomPageEditor ? history.push('/custom-pages') : history.push('/static-pages')
    }
  }

  const updatePage = async () => {
    let data = pageData.type === 'STATIC' ? { content: htmlData } : { components: componentData }

    if (!isEmpty(pageData)) {
      await pagesUpdateCall({
        params: {
          custom_page_id: pageData?._id,
        },
        data: { name: pageData.name, ...data },
      })
    }
  }
  const onSwap = (componentId, operation) => {
    const componentIndex = componentData.findIndex((info) => info.data?.id === componentId)

    if (componentIndex < 0) return

    if (operation === 'up' && componentIndex > 0) {
      setComponentData((prevState) => {
        let data = [...prevState]

        let temp = data[componentIndex - 1]
        data[componentIndex - 1] = data[componentIndex]
        data[componentIndex] = temp

        return [...data]
      })
    }
    if (operation === 'down' && componentIndex < componentData.length - 1) {
      setComponentData((prevState) => {
        let data = [...prevState]

        let temp = data[componentIndex + 1]
        data[componentIndex + 1] = data[componentIndex]
        data[componentIndex] = temp

        return [...data]
      })
    }
  }

  const onDeleteComponent = () => {
    setComponentData((prevState) =>
      prevState.filter((info) => info.data.id !== selectedComponentId),
    )
    setSelectedComponentId('')
    setDeleteModal(false)
  }
  const handleDelete = (componentId) => {
    setSelectedComponentId(componentId)
    setDeleteModal(true)
  }

  const onCopy = (componentId) => {
    const componentInfo = componentData.find((info) => info.data?.id === componentId)
    const componentIndex = componentData.findIndex((info) => info.data?.id === componentId)
    let tempComponentArr = componentData
    if (componentIndex > -1 && componentInfo) {
      let newComponentObj = JSON.parse(
        JSON.stringify({
          ...componentInfo,
          data: {
            ...componentInfo.data,
            id: uuid(),
          },
        }),
      )

      tempComponentArr.splice(componentIndex + 1, 0, newComponentObj)
    }
    setComponentData([...tempComponentArr])
  }

  // const downloadImage = async () => {
  //   const imageUrl = await htmlToImage.toPng(templateRef.current)
  //   console.log('dataUrl', imageUrl)

  //   // let blob = await fetch(
  //   //   'https://d1pg44wvryhaci.cloudfront.net/public/images/infinity_film_banner1667415386298.png',
  //   //   { mode: 'no-cors' },
  //   // ).then((r) => r.blob())
  //   // console.log('blob', blob)
  //   // debugger
  //   // download image
  //   const link = document.createElement('a')
  //   link.download = 'html-to-img.png'
  //   link.href = imageUrl
  //   link.click()
  // }

  const getComponent = (key, data) => {
    let componentProps = {
      componentData: data,
      modifyData: modifyComponent,
      setModalState: setModalState,
      isEdit: isEdit,
      onSwap: onSwap,
      onDelete: handleDelete,
      onCopy: onCopy,
      onAdd: setAddModalState,
    }
    let componentObj = {
      rowingHeroSection: <RowingHeroSection {...componentProps} />,
      asymmetricFlow: <AsymmetricFlow {...componentProps} />,
      promotionalLead: <PromotionalLead {...componentProps} />,
      passimCarve: <PassimCarve {...componentProps} />,
      passimCarvePlayer: <PassimCarvePlayer {...componentProps} />,
      inventorySlide: <InventorySlide {...componentProps} />,
      classyBanners: <ClassyBanners {...componentProps} />,
      classyBannersPlayer: <ClassBannerPlayer {...componentProps} />,
      narrowAdmonition: <NarrowAdmonition {...componentProps} />,
      definityCards: <DefinityCards {...componentProps} />,
      fineTunedGallery: <FineTunedGallery {...componentProps} />,
      flyerIntro: <FlyerIntro {...componentProps} />,
      mementoSlides: <MementoSlides {...componentProps} />,
      wedgedInfo: <WedgedInfo {...componentProps} />,
      decomposedBanners: <DecomposedBanners {...componentProps} />,
      extensiveCarouselRendition: <ExtensiveCarouselRendition {...componentProps} />,
      adNCarousel: <AdNCarousel {...componentProps} />,
      extensiveCarousel: <ExtensiveCarouselSimple {...componentProps} />,
      tripleCardCarousel: <TripleCardCarousel {...componentProps} />,
      bobbingCards: <BobbingCards {...componentProps} />,
      defaultBanner: <DefaultBanner {...componentProps} />,
      defaultBannerPlayer: <DefaultBannerPlayer {...componentProps} />,
      defaultSwimlane: <DefaultSwimlane {...componentProps} />,
      artistSwimlane: <DefaultArtistSwimlane {...componentProps} />,
      venueSwimlane: <DefaultVenueSwimlane {...componentProps} />,
    }

    return componentObj[key]
  }

  const getModal = (selectedModalObj) => {
    const { keyID } = selectedModalObj

    const selectedComponent = componentData.find((info) => info?.data?.id === keyID)
    // console.log('selectedComponent', selectedComponent, keyID, selectedModalObj)
    let modalProps = {
      componentData: selectedComponent.data,
      modifyData: modifyComponent,
      modalSpecificData: selectedModalObj,
      onCancel: () => setModalState({}),
    }
    if (selectedComponent) {
      let modalObj = {
        rowingHeroSection: <RosemaryCarouselModal {...modalProps} />,
        asymmetricFlow: <RosemaryToptrendingModal {...modalProps} />,
        promotionalLead: <RosemaryMomentModal {...modalProps} />,
        passimCarve: <RosemaryRecentStoriesModal {...modalProps} />,
        passimCarvePlayer: <PassimCarvePlayerModal {...modalProps} />,
        inventorySlide: <RosemaryCategoriesModal {...modalProps} />,
        classyBanners: <FitnessHeroModal {...modalProps} />,
        classyBannersPlayer: <ClassyBannerPlayerModal {...modalProps} />,
        narrowAdmonition: <FitnessYogaAdModal {...modalProps} />,
        definityCards: <FitnessClassesModal {...modalProps} />,
        fineTunedGallery: <FitnessPlansModal {...modalProps} />,
        flyerIntro: <FitnessTrainerModal {...modalProps} />,
        mementoSlides: <FitnessGalleriesModal {...modalProps} />,
        wedgedInfo: <FitnessPackagesModal {...modalProps} />,
        decomposedBanners: <DecomposedBannersModal {...modalProps} />,
        extensiveCarouselRendition: <ExtensiveCarouselRenditionModal {...modalProps} />,
        adNCarousel: <AdNCarouselModal {...modalProps} />,
        extensiveCarousel: <ExtensiveCarouselSimpleModal {...modalProps} />,
        tripleCardCarousel: <TripleCardCarouselModal {...modalProps} />,
        bobbingCards: <BobbingCardsModal {...modalProps} />,
        defaultBanner: <DefaultBannerModal {...modalProps} />,
        defaultBannerPlayer: <DefaultBannerPlayerModal {...modalProps} />,
        defaultSwimlane: <DefaultSwimlaneModal {...modalProps} />,
        artistSwimlane: <DefaultArtistSwimlaneModal {...modalProps} />,
        venueSwimlane: <DefaultVenueSwimlaneModal {...modalProps} />,
      }
      return modalObj[selectedComponent.data.component_key]
    }
  }

  const modifyComponent = (keyID, data) => {
    const selectedComponent = componentData.find((info) => info.data.id === keyID)

    if (selectedComponent) {
      selectedComponent.data.data = data
      setComponentData([...componentData], selectedComponent)
      setModalState({})
    }
  }

  const addComponent = (componentInfo) => {
    let componentId = addModalState.keyID
    const componentIndex = componentData.findIndex((info) => info.data?.id === componentId)
    let tempComponentArr = componentData

    let newComponentObj = JSON.parse(
      JSON.stringify({
        ...componentInfo,
        data: {
          ...componentInfo.data,
          id: uuid(),
        },
      }),
    )

    if (componentIndex > -1 && componentInfo) {
      tempComponentArr.splice(componentIndex + 1, 0, newComponentObj)
    }

    if (!componentId) {
      tempComponentArr.push(newComponentObj)
    }

    setComponentData([...tempComponentArr])
  }

  const handleCloseEditor = () => {
    isCustomPageEditor ? history.push('/custom-pages') : history.push('/static-pages')
  }

  const [charCount, setCharCount] = useState(0)

  // Update character count when text changes
  useEffect(() => {
    // console.log(htmlData)
  }, [htmlData])

  return (
    <div>
      <div
        style={{ backgroundColor: '#f5f3f3' }}
        className="d-flex justify-content-between align-items-center h-100 px-5 border py-3"
      >
        <div style={{ width: '30%' }} className=""></div>
        <div style={{ width: '35%' }} className="text-center">
          <span style={{ fontSize: '1rem', fontWeight: 'bold' }}>{pageData?.name}</span>
          <CFormText>
            {createPageUrl(
              accountObj?.domain_name,
              pageData?.page_url,
              isCustomPageEditor ? '/custom' : '/static',
            )}
          </CFormText>
        </div>
        <div style={{ width: '35%' }} className=" d-flex justify-content-end">
          <CButton
            className="mx-3 bg-black rounded-1 btn-focus-none"
            onClick={updatePage}
            style={{ opacity: premiumComponentExist ? '0.3' : '1' }}
            disabled={premiumComponentExist}
          >
            Save
          </CButton>
          <CButton
            className="mx-3 bg-black rounded-1 btn-focus-none"
            onClick={async () => {
              await updatePage()
              isCustomPageEditor ? history.push('/custom-pages') : history.push('/static-pages')
            }}
            style={{ opacity: premiumComponentExist ? '0.3' : '1' }}
            disabled={premiumComponentExist}
          >{`Save & Exit`}</CButton>
          <img
            src={CloseIcon}
            alt="CloseIcon"
            className="mx-4 cursor-pointer"
            onClick={() => setEditorCloseModal(true)}
          />
        </div>
      </div>
      {!pagesListLoading ? (
        <>
          {isCustomPageEditor ? (
            <>
              {isEmpty(componentData) ? (
                <div style={{ height: '68vh', width: '100%' }}>
                  <div className="d-flex flex-column align-items-center justify-content-center h-100">
                    <CImage
                      src={AddIcon}
                      style={{
                        marginBottom: '10px',
                      }}
                      className="cursor-pointer"
                      onClick={() =>
                        setAddModalState({
                          keyID: '',
                          modalData: {},
                        })
                      }
                    />
                    <p
                      style={{ color: '#747272' }}
                      className="cursor-pointer"
                      onClick={() =>
                        setAddModalState({
                          keyID: '',
                          modalData: {},
                        })
                      }
                    >
                      Add Component
                    </p>
                  </div>
                </div>
              ) : (
                <div className="flex justify-content-center ">
                  <div
                    id="templateRef"
                    ref={templateRef}
                    className="static-scrollbar-class position-relative"
                    style={{ height: '90vh', width: '100%' }}
                  >
                    <ThemeProvider theme={themes[themeIndex]}>
                      <div style={{ background: themes[themeIndex]?.c1 }}>
                        {componentData.map((info, index) => {
                          const isPremiumComponent = checkPremiumComponentId(info._id)
                          return (
                            <div className="position-relative" key={index}>
                              {isPremiumComponent && (
                                <div
                                  className="position-absolute top-0 text-white rounded-lg"
                                  style={{
                                    fontSize: '1.302vw',
                                    fontWeight: 'bold',
                                    zIndex: '60',
                                    marginTop: '4px',
                                    left: '3.8vw',
                                    backgroundColor: '#00000040',
                                    padding: '0.416vw 0.729vw 0.364vw',
                                  }}
                                >
                                  PREMIUM COMPONENT
                                </div>
                              )}
                              {getComponent(info.data.component_key, info.data)}
                            </div>
                          )
                        })}
                      </div>
                    </ThemeProvider>
                  </div>
                </div>
              )}

              {!isEmpty(modalState) && getModal(modalState)}
              {deleteModal && (
                <DeleteModal
                  openModal={deleteModal}
                  title={`Are you sure you want to delete this Component ?`}
                  confirmButtonText={`Yes`}
                  onCancel={() => {
                    setSelectedComponentId('')
                    setDeleteModal(false)
                  }}
                  onConfirm={onDeleteComponent}
                />
              )}

              {!isEmpty(addModalState) && (
                <AddSectionModal
                  data={
                    baseComponentList?.data.filter((info) =>
                      info.data.category === 'header' || info.data.category === 'footer'
                        ? false
                        : true,
                    ) || []
                  }
                  onCancel={() => setAddModalState({})}
                  onAdd={addComponent}
                />
              )}
            </>
          ) : (
            <div style={{ background: '#e5e5e5', minHeight: '91vh' }}>
              <div className="d-flex justify-content-center align-items-center pt-5">
                <div
                  style={{
                    width: '920px',
                  }}
                >
                  <h4 style={{ marginTop: '5px' }}>Add Text</h4>
                  <p style={{ fontSize: '14px', color: '#707070' }}>
                    Choose your website page and customize it as per your needs.{' '}
                  </p>
                </div>
              </div>
              <div className="mt-4 d-flex align-items-center">
                <div
                  style={{
                    margin: 'auto',
                    width: '920px',
                    background: '#fff',
                    // height: '20vw',
                  }}
                  className="static-editor"
                >
                  <Editor
                    value={htmlData}
                    handleChange={(content, delta, source, editor) => {
                      setHtmlData(content)
                      setTotalWordCount(editor.getLength() - 1)
                    }}
                  />
                </div>
              </div>
              <div
                style={{
                  width: '920px',
                  margin: 'auto',
                  display: 'flex',
                  justifyContent: 'flex-end',
                }}
              >
                <p>Characters Count: {totalWordCount}</p>
              </div>
            </div>
          )}
        </>
      ) : null}
      {editorCloseModal && (
        <DeleteModal
          openModal={editorCloseModal}
          title={`Are you sure you want to Close the Editor ?`}
          confirmButtonText={`Yes`}
          onCancel={() => setEditorCloseModal(false)}
          onConfirm={handleCloseEditor}
        />
      )}
    </div>
  )
}

export default StaticPageEditor
